import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderStatus from "@/enum/OrderStatus";
import React from "react";
import OrderItemStatusLabel from "../../../../../../../components/OrderItemImage/OrderItemStatusLabel";
import classnames from "classnames";
import { observer } from "mobx-react-lite";

interface OrderItemTitleExternalIdPropElementProps {
    orderItem: OrderItemDTO;
    orderStatus: OrderStatus;
    hasAbnormal: boolean;
}

/**
 * 简称+编码+属性
 * 最后降级显示组件
 */
const OrderItemTitleExternalIdPropElement: React.FC<OrderItemTitleExternalIdPropElementProps> = observer(function (
    props,
) {
    const { orderItem, orderStatus, hasAbnormal } = props;

    const title = orderItem.simpleTitle || orderItem.title;
    const externalId = orderItem.skuExternalId || orderItem.productExternalId;
    const skuProperties = orderItem.localSkuProperties || orderItem.skuProperties;
    const skuPropertiesEl = skuProperties ? `（${skuProperties}）` : null;

    return (
        <p key={orderItem.id} className="order-item-title">
            <span className="break-spaces">{title}</span>
            {externalId}
            <span className="break-spaces">{skuPropertiesEl}</span>
            <span
                className={classnames(
                    "mr10",
                    orderItem.quantity >= 2 ? "high-light-order-item-quantity" : "order-item-quantity",
                )}
            >
                × {orderItem.quantity}
                {orderItem.canceledQuantity > 0 ? (
                    <span className="text-danger font-bold fs11">（取消数量：{orderItem.canceledQuantity}）</span>
                ) : null}
            </span>
            {orderStatus !== orderItem.status || (orderItem.status === OrderStatus.CANCELED && hasAbnormal) ? (
                <OrderItemStatusLabel status={orderItem.status} />
            ) : null}
        </p>
    );
});

export default OrderItemTitleExternalIdPropElement;
